import React, { ReactElement } from 'react'
import { AdminUI, AdminUIProps } from 'react-admin'
import { usePermissionProvider } from '../../contexts/rbac-context'
import { ResourceChild } from './type'

export const RbacAdminUI: React.FC<AdminUIProps> = (props) => {
  const {
    layout,
    dashboard,
    disableTelemetry,
    menu,
    catchAll,
    title,
    loading,
    loginPage,
    notification,
    requireAuth,
    ready,
    children,
  } = props
  const { currentPermissions, registerResourcePropsWithPermission } = usePermissionProvider()

  return (
    <AdminUI
      layout={layout}
      dashboard={dashboard}
      disableTelemetry={disableTelemetry}
      menu={menu}
      catchAll={catchAll}
      title={title}
      loading={loading}
      loginPage={loginPage}
      notification={notification}
      requireAuth={requireAuth}
      ready={ready}
    >
      {React.Children.map(children as ReactElement[], (child: ResourceChild) => {
        const { raName = null } = child.type

        if (currentPermissions && raName === 'Resource') {
          const updatePropsWithPermissions = registerResourcePropsWithPermission(
            child.props,
            currentPermissions,
          )

          return React.cloneElement(child, updatePropsWithPermissions, null)
        }
        return child
      })}
    </AdminUI>
  )
}
